import React, { useState, useEffect } from 'react';
import { Form, Input, Button } from "reactstrap";
import useGlobal from '../../store';


const AddGiftlistForm = (props) => {

    const [isSaving, setIsSaving] = useState(false);

    const [response, userActions] = useGlobal(
        state => state.response,
        actions => actions.userActions
    );

    useEffect(() => {
        if(!response || response.type !== "updateprofile") {
            return;
        }
        setIsSaving(false);
    }, [response])

    const [formState, setFormState] = useState({
        FirstName: '',
        LastName: '',
        about: '',
        connection: '',
        gender: 'male',
        ageRange: 'child'
    });

    const submitForm = async (event) => {
        event.preventDefault();
        console.log('submitting form...');
        setIsSaving(true);
        const justFormData = new FormData(event.target);
        var object = {};
        justFormData.forEach((value, key) => {object[key] = value});
        const formData = { ...formState };
        formData.FirstName = formData.FullName.split(" ", 2)[0];
        formData.LastName = formData.FullName.split(" ", 2).length > 1 ? formData.FullName.split(" ", 2)[1] : "";
        delete formData.FullName;
        console.log('FORM DATA', formData);
        userActions.addGiftlist(formData);
    }

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let formFields = { ...formState };
        formFields[name] = value;
        setFormState(formFields);
    }

    const genderOptions = ['male', 'female'];
    const ageRangeOptions = ['baby','toddler','child','teen','young-adult','adult','senior'];

    return (
        <Form onSubmit={submitForm} className="kt-form kt-form--label-right">

            <div className="form-group">
                <label>Full Name</label>
                <input type="text" name="FullName" value={formState.FullName || ''} onChange={handleInputChange} className="form-control" aria-describedby="emailHelp" placeholder="Name" />
            </div>

            <div className="form-group">
                <label>About</label>
                <span className="form-text text-muted">Provide a short description of this person's interests, clothing sizes, etc. Anything that might help others find a great gift.</span>
                <Input type="textarea" name="about" value={formState.about || ''} onChange={handleInputChange} options={genderOptions}></Input>
            </div>

            <div className="form-group">
                <label>Gender</label>
                <Input type="select" name="gender" value={formState.gender || ''} onChange={handleInputChange} >
                    {genderOptions.map(opt => <option key={opt}>{opt}</option>)}
                </Input>
            </div>

            <div className="form-group">
                <label>Age Range</label>
                <Input type="select" name="ageRange" value={formState.ageRange || ''} onChange={handleInputChange}>
                    {ageRangeOptions.map(opt => <option key={opt}>{opt}</option>)}
                </Input>
            </div>
            
            <div className="form-group">
                <Button color="success" type="submit">
                    <i className="flaticon2-plus-1"></i> 
                    ADD GIFT LIST
                    { isSaving ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></> }
                </Button>
            </div>
            
        </Form>);
}
export default AddGiftlistForm;